<template>
  <component :is="tag" class="w-flex" :class="componentClasses">
    <slot />
  </component>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';

import { defaults } from '../../../composables/defaults';
import { withAlignProps, useAlignProps } from '../../../composables/props/align';
import { withDirectionProps, useDirectionProps } from '../../../composables/props/direction';
import { withFluidProps, useFluidProps } from '../../../composables/props/fluid';
import { withGapProps, useGapProps, useGapXProps, useGapYProps } from '../../../composables/props/gap';
import { withJustifyProps, useJustifyProps } from '../../../composables/props/justify';
import { withTagProps } from '../../../composables/props/tag';
import { withTextAlignProps, useTextAlignProps } from '../../../composables/props/textAlign';
import { withWrapProps, useWrapProps } from '../../../composables/props/wrap';

// Komponent wiersza z kolekcji w-grid
export default defineComponent({
  props: {
    ...withGapProps(defaults.flex.gap),
    ...withJustifyProps(defaults.flex.justify),
    ...withAlignProps(defaults.flex.align),
    ...withWrapProps(defaults.flex.wrap),
    ...withFluidProps(defaults.flex.fluid),
    ...withTagProps(defaults.flex.tag),
    ...withTextAlignProps(),
    ...withDirectionProps
  },

  setup(props) {
    const componentName = 'w-flex';

    // Klasy komponentu
    const justifyClasses = useJustifyProps(componentName, props);
    const alignClasses = useAlignProps(componentName, props);
    const directionClasses = useDirectionProps(componentName, props);
    const gapClasses = useGapProps('', props);
    const gapXClasses = useGapXProps('', props);
    const gapYClasses = useGapYProps('', props);
    const wrapClasses = useWrapProps(componentName, props);
    const textAlignClasses = useTextAlignProps(props);
    const fluidProps = useFluidProps(componentName, props);

    const componentClasses = computed(() => {
      return [
        justifyClasses.value,
        alignClasses.value,
        directionClasses.value,
        gapClasses.value,
        gapXClasses.value,
        gapYClasses.value,
        wrapClasses.value,
        textAlignClasses.value,
        fluidProps.value
      ];
    });
    return { componentClasses };
  }
});
</script>
<style lang="scss">
@use 'WFlex';
</style>
